import { SnackbarProvider } from 'notistack';
import Collapse from '@material-ui/core/Collapse';
import NotificationDisplay from './NotificationDisplay';

const Notifications = () => {
  return <>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      TransitionComponent={Collapse}
    >
      <NotificationDisplay />
    </SnackbarProvider>
  </>;
};

export default Notifications;
